var _path, _g, _path2, _g2, _path3, _g3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneStack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19353_56896",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 14,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4793 2.94141H3.44336L6.65788 16.3074H16.6938L13.4793 2.94141Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19353_56896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.66156 3.84498C3.54143 3.34595 3.86861 2.94141 4.39231 2.94141H12.5317C13.0554 2.94141 13.5774 3.34595 13.6975 3.84498L16.4798 15.4032C16.5999 15.9022 16.2727 16.3067 15.749 16.3067H7.60961C7.08588 16.3067 6.56394 15.9022 6.44384 15.4032L3.66156 3.84498Z",
    fill: "url(#paint0_linear_19353_56896)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_19353_56896",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 13,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4517 3.32617H4.40039L6.71832 12.9641H16.7696L14.4517 3.32617Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_19353_56896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.67719 4.22975C4.55705 3.73072 4.88423 3.32617 5.40796 3.32617H11.7353C12.259 3.32617 12.7809 3.73071 12.901 4.22975L14.6114 11.3352C14.7316 11.8342 14.4044 12.2388 13.8807 12.2388H7.55341C7.02968 12.2388 6.50774 11.8342 6.3876 11.3352L4.67719 4.22975Z",
    fill: "url(#paint1_linear_19353_56896)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0401 10.2151C16.986 10.2151 18.8264 7.93955 18.1506 5.13252C17.475 2.32546 14.539 0.0499071 11.5931 0.0499071C8.6472 0.0499071 6.80681 2.32546 7.48252 5.13252C8.15823 7.93955 11.0942 10.2151 14.0401 10.2151ZM14.0582 10.2904C17.0478 10.2904 18.9154 7.98113 18.2297 5.13252C17.544 2.28388 14.5646 -0.0253906 11.575 -0.0253906C8.58543 -0.0253906 6.71781 2.28388 7.4035 5.13252C8.08923 7.98113 11.0686 10.2904 14.0582 10.2904Z",
    fill: "url(#paint2_linear_19353_56896)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2589 12.5862C20.2048 12.5862 22.0451 10.3106 21.3694 7.50359C20.6937 4.69656 17.7578 2.421 14.8119 2.421C11.866 2.421 10.0256 4.69656 10.7013 7.50359C11.377 10.3106 14.3129 12.5862 17.2589 12.5862ZM17.277 12.6615C20.2665 12.6615 22.1342 10.3522 21.4484 7.50359C20.7627 4.65498 17.7833 2.3457 14.7938 2.3457C11.8042 2.3457 9.93653 4.65498 10.6223 7.50359C11.308 10.3522 14.2874 12.6615 17.277 12.6615Z",
    fill: "url(#paint3_linear_19353_56896)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_19353_56896",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 14,
    height: 14
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9969 6.29883H9.96094L6.74366 19.6642H16.7796L19.9969 6.29883Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_19353_56896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.7583 7.20237C9.8784 6.70335 10.4003 6.29883 10.9241 6.29883H19.0635C19.5872 6.29883 19.9144 6.70335 19.7942 7.20237L17.012 18.7606C16.8918 19.2596 16.3699 19.6642 15.8462 19.6642H7.70677C7.18309 19.6642 6.8559 19.2596 6.976 18.7606L9.7583 7.20237Z",
    fill: "url(#paint4_linear_19353_56896)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3932 7.81179C10.5134 7.31277 11.0353 6.9082 11.559 6.9082H18.2749C18.7986 6.9082 19.1258 7.31277 19.0057 7.81179L17.3795 14.5674C17.2593 15.0664 16.7374 15.471 16.2137 15.471H9.49779C8.9741 15.471 8.64692 15.0664 8.76702 14.5674L10.3932 7.81179Z",
    fill: "url(#paint5_linear_19353_56896)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2845 13.1878C19.2305 13.1878 22.1664 10.9122 22.8421 8.10516C23.5178 5.29812 21.6774 3.02256 18.7315 3.02256C15.7856 3.02256 12.8497 5.29812 12.1739 8.10516C11.4982 10.9122 13.3386 13.1878 16.2845 13.1878ZM16.2664 13.2631C19.256 13.2631 22.2354 10.9538 22.9211 8.10516C23.6068 5.25654 21.7392 2.94727 18.7496 2.94727C15.76 2.94727 12.7806 5.25654 12.0949 8.10516C11.4092 10.9538 13.2768 13.2631 16.2664 13.2631Z",
    fill: "url(#paint6_linear_19353_56896)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3607 15.5588C21.3066 15.5588 24.2425 13.2833 24.9182 10.4763C25.594 7.66919 23.7536 5.39367 20.8076 5.39367C17.8617 5.39367 14.9258 7.66919 14.2501 10.4763C13.5744 13.2833 15.4148 15.5588 18.3607 15.5588ZM18.3426 15.6341C21.3322 15.6341 24.3115 13.3249 24.9973 10.4763C25.683 7.62761 23.8153 5.31836 20.8258 5.31836C17.8362 5.31836 14.8568 7.62761 14.1711 10.4763C13.4854 13.3249 15.353 15.6341 18.3426 15.6341Z",
    fill: "url(#paint7_linear_19353_56896)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0349 2.2168C17.0349 2.53826 17.527 3.26157 17.7728 3.26157C17.5438 3.26157 17.137 3.67978 17.0821 4.19163C17.0846 4.23144 17.0827 4.26989 17.0759 4.30635C17.0759 4.26769 17.078 4.22945 17.0821 4.19163C17.0575 3.79309 16.6026 3.26157 16.3789 3.26157C16.543 3.26157 17.0349 2.89188 17.0349 2.2168Z",
    fill: "url(#paint8_linear_19353_56896)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07017 15.1387C5.07017 15.3486 5.37771 15.821 5.53137 15.821C5.38827 15.821 5.13399 16.0941 5.09968 16.4283C5.10121 16.4544 5.10001 16.4794 5.09576 16.5033C5.09576 16.478 5.09718 16.453 5.09968 16.4283C5.08433 16.1681 4.79999 15.821 4.66016 15.821C4.76274 15.821 5.07017 15.5795 5.07017 15.1387Z",
    fill: "url(#paint9_linear_19353_56896)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.122 17.9961C18.122 18.1929 18.3834 18.6358 18.514 18.6358C18.3923 18.6358 18.1763 18.8918 18.147 19.2052C18.1483 19.2295 18.1474 19.2531 18.1437 19.2754C18.1437 19.2517 18.145 19.2283 18.147 19.2052C18.1341 18.9612 17.8923 18.6358 17.7734 18.6358C17.8606 18.6358 18.122 18.4095 18.122 17.9961Z",
    fill: "url(#paint10_linear_19353_56896)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6511 17.4919C16.6697 17.5796 18.2277 16.9945 18.9836 15.8322C19.7395 14.6699 19.6218 13.0403 18.6866 11.287C17.7563 9.54303 16.0466 7.74439 13.7674 6.32388C11.4883 4.90333 9.10016 4.14783 7.09237 4.06063C5.07386 3.97296 3.5158 4.55803 2.75989 5.72034C2.00398 6.8826 2.12172 8.51216 3.05696 10.2655C3.98724 12.0095 5.69695 13.8081 7.97608 15.2287C10.2553 16.6492 12.6434 17.4047 14.6511 17.4919ZM7.78895 15.5165C12.4314 18.4099 17.575 18.6333 19.2776 16.0154C20.9802 13.3975 18.597 8.9296 13.9546 6.03608C9.31217 3.14258 4.16854 2.91918 2.46593 5.5371C0.763335 8.15506 3.14653 12.6229 7.78895 15.5165Z",
    fill: "url(#paint11_linear_19353_56896)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19353_56896",
    x1: 13.48,
    y1: 2.94141,
    x2: 2.18748,
    y2: 5.91995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB79F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#5F49B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19353_56896",
    x1: 4.18284,
    y1: 8.07956,
    x2: 13.2995,
    y2: 5.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_19353_56896",
    x1: 17.9719,
    y1: 5.13252,
    x2: 8.22599,
    y2: 7.47851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9000C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_19353_56896",
    x1: 21.1907,
    y1: 7.50359,
    x2: 11.4448,
    y2: 9.84963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9000C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_19353_56896",
    x1: 20.0117,
    y1: 6.29883,
    x2: 10.193,
    y2: 4.12819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB79F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#5F49B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_19353_56896",
    x1: 9.51142,
    y1: 11.475,
    x2: 17.6521,
    y2: 13.4346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_19353_56896",
    x1: 22.6633,
    y1: 8.10516,
    x2: 12.9174,
    y2: 5.75912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9000C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_19353_56896",
    x1: 24.7395,
    y1: 10.4763,
    x2: 14.9936,
    y2: 8.13023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9000C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_19353_56896",
    x1: 16.379,
    y1: 3.33123,
    x2: 17.773,
    y2: 3.33123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_19353_56896",
    x1: 4.66027,
    y1: 15.8664,
    x2: 5.53148,
    y2: 15.8664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_19353_56896",
    x1: 17.7736,
    y1: 18.6783,
    x2: 18.5142,
    y2: 18.6783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_19353_56896",
    x1: 10.8859,
    y1: 9.19693,
    x2: 7.89461,
    y2: 15.5661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF96FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF96FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneStack);
export default __webpack_public_path__ + "static/media/phone-stack.f00e7ee92e2fac5552d4d383f619e683.svg";
export { ForwardRef as ReactComponent };